// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5c8cb2b0","455":"886df818","977":"c12765db"}[chunkId] + ".chunk.js";
};